import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import { preloadEditButton } from '@confluence/edit-button/entry-points/preloadEditButton.js';

export type preloadGroupedButtonsProps = {
	contentId: string;
	spaceKey: string;
	shouldPreloadUsingSpaceKey?: boolean;
};

export function preloadGroupedButtons({ contentId, spaceKey }: preloadGroupedButtonsProps) {
	return SSRMeasures.run('ssr-app/prepare/preloadQuery/fetch:pageButtons', async () => {
		const tasks: Promise<any>[] = [preloadEditButton({ spaceKey, contentId })];
		return waitForAllReturnWhenError(tasks);
	});
}
